import * as requests from "../../coraWebComponents/utils/requests";
import urls from "../../constants/Urls";

const buildOdberatel = (id = "") => {
  return `${urls.Odberatel}/${id}`;
};

export const getOdberatel = async (id) => {
  if (id === 0) {
    return null;
  }

  const url = buildOdberatel(id);
  try {
    let res = await requests.get(url);
    return res;
  } catch (error) {
    throw error;
  }
};

export const getListOdberatel = async (filter, sort, page) => {
  const url = buildOdberatel();
  try {
    let res = await requests.getList(url, filter, sort, page);
    return res;
  } catch (error) {
    throw error;
  }
};

export const updateOdberatel = async (data) => {
  const url = `${buildOdberatel()}update`;

  try {
    let res = await requests.post(url, data);
    return res;
  } catch (error) {
    throw error;
  }
};
